import React from "react"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import TitleBannerEnquiry from "../components/titleBanner/TitleBannerEnquiry"
import CardsList from "../components/common/cardsList/CardsList"
import { getCourseItemListJsonLd } from "../utils/jsonld"

const CoursesBim = ({ data }) => {
  const { bimCourses } = data
  return (
    <div>
      <SEO
        title="BIM Courses"
        // description=""
        jsonLd={getCourseItemListJsonLd(bimCourses.nodes, {
          listName: "BIM Courses at Ace Industrial Academy"
        })}
      />

      <TitleBannerEnquiry
        title="BIM Courses"
        description="We conduct trainings with BIM Courses for AutoCad, Revit, ProjectWise360, BIM360 and many more"
        withOnlyDescription
      />

      <div className="container">
        <CardsList
          courses={bimCourses.nodes}
          withoutFilter
        />
      </div>
    </div>
  )
}

export const awsQuery = graphql`
  query allBimQuery {
    bimCourses: allContentfulTraining(
      filter: { category: { eq: "bim" } }
    ) {
      nodes {
        id
        title
        category
        courseReference
        trainingMode
        updatedAt
        slug
        requirements
        lessons
        product {
          id
          name
          netFee
          price
        }
        duration
        coverPhoto {
          gatsbyImageData
        }
        courseRuns
      }
    }
  }
`

export default CoursesBim
